import i18n from '@/lang/index.js' // 引入中英文语言翻译文件
const regions = [
    {regions:"ID",code:"62",name:"ឥណ្ឌូនេស៊ី",flag: require('@/assets/flag/id.svg'),alias:"印尼",select:false},
    {regions:"IN",code:"91",name:"ឥណ្ឌា",flag: require('@/assets/flag/in.svg'),alias:"印度",select:false},
    {regions:"JP",code:"81",name:"ជប៉ុន",flag: require('@/assets/flag/jp.svg'),alias:"日本",select:false},
    {regions:"KR",code:"82",name:"កូរ៉េខាងត្បូង",flag: require('@/assets/flag/kr.svg'),alias:"韩国",select:false},
    {regions:"MY",code:"60",name:"ប្រទេសម៉ាឡេស៊ី",flag: require('@/assets/flag/my.svg'),alias:"马来西亚",select:false},
    {regions:"TH",code:"66",name:"ថៃ",flag: require('@/assets/flag/th.svg'),alias:"泰国",select:false},
    {regions:"VN",code:"84",name:"វៀតណាម",flag: require('@/assets/flag/vn.svg'),alias:"越南",select:false},
    {regions:"KH",code:"855",name:"កម្ពុជា",flag: require('@/assets/flag/kh.svg'),alias:"柬埔寨",select:true}
]
export default regions


// WEBPACK FOOTER //
// ./src/lang/regions.js